<template>
    <Modal id="about-modal"
           icon="fa-circle-info"
           cancel-label="CLOSE"
           :cancel="cancel"
           title="ABOUT.MODAL_TITLE"
           size="lg">
        <div class="about">
            <div>
                <AboutVersionSection @close="resolve" />
                <AboutServiceWorkersSection />
            </div>

            <div>
                <AboutDeviceSection />
                <AboutUserSection />
                <AboutBranchSection />
            </div>

            <div>
                <AboutConnectionSection />
                <AboutQueueSection />
            </div>
        </div>
    </Modal>
</template>

<script>
import AboutBranchSection from '@/epos/vue/modals/About/sections/AboutBranchSection';
import AboutConnectionSection from '@/epos/vue/modals/About/sections/AboutConnectionSection';
import AboutDeviceSection from '@/epos/vue/modals/About/sections/AboutDeviceSection';
import AboutQueueSection from '@/epos/vue/modals/About/sections/AboutQueueSection';
import AboutServiceWorkersSection from '@/epos/vue/modals/About/sections/AboutServiceWorkersSection';
import AboutUserSection from '@/epos/vue/modals/About/sections/AboutUserSection';
import AboutVersionSection from '@/epos/vue/modals/About/sections/AboutVersionSection';
import Modal from '@/vue/components/Modals/Modal';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    components: {
        Modal,
        AboutBranchSection,
        AboutConnectionSection,
        AboutDeviceSection,
        AboutQueueSection,
        AboutServiceWorkersSection,
        AboutUserSection,
        AboutVersionSection,
    },

    mixins: [
        ModalPropsMixin,
    ],
};

</script>

<style lang="less">
@import "./about";
</style>
